module.exports = __webpack_public_path__ + "static/media/logo-green.0ef2dd57.svg";